let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9XYQ9"), load("6MNAi"), load("425pi"), load("efZH2")]).then(() => parcelRequire('mS2VM'));